try {
/* === SBO #111 – ES5, cross-device speed build (all CSS included) === */
(function () {
  "use strict";

  /* === URL guard – skip excluded product pages === */
  var _EXCLUDED = [
    '/products/deep-winter-bundle',
    '/products/deep-winter-candle',
    '/products/deep-sleep-bundle',
    '/products/deep-sleep-mask',
    '/products/handmade-mushroom-mug',
    '/products/sweet-bee-organics-gift-card',
    '/products/tote-bag'
  ];
  var _p = window.location.pathname.replace(/\/$/, '').toLowerCase();
  for (var _i = 0; _i < _EXCLUDED.length; _i++) {
    if (_p === _EXCLUDED[_i] || _p.indexOf(_EXCLUDED[_i]) === 0) return;
  }
  /* === end URL guard === */

  window.__cwSkioSyncConfig = window.__cwSkioSyncConfig || {};
  window.__cwSkioSyncConfig.badgeTxt120ml = 'Save over £5 per jar';

  /* ---------------- helpers ---------------- */
  var HOST_SEL = 'skio-plan-picker';
  var CW_DEBUG = false;
  var CW_PRODUCT_HANDLE = 'sweet-sleep-magnesium-butter';

  function isTargetProduct(){
    var path = window.location.pathname.replace(/\/$/, '').toLowerCase();
    return path === '/products/' + CW_PRODUCT_HANDLE || path.indexOf('/products/' + CW_PRODUCT_HANDLE + '/') === 0;
  }

  function is120mlSelected(){
    var selectedSize = document.querySelector('input[type="radio"][name="Size"]:checked');
    return !!(selectedSize && /^120ml\b/i.test(selectedSize.value || ''));
  }

  function isOneTimeGroup(ct){
    if (!ct) return false;
    if (ct.classList && ct.classList.contains('one-time')) return true;

    var input = q(ct, '.group-input[type="radio"]');
    if (input && /One[\s-]*time/i.test(input.value || '')) return true;

    return /One[\s-]*time purchase/i.test(ct.textContent || '');
  }

  function log(s){
    if (!CW_DEBUG) return;
    var id = 'cw-ios-debug-tag';
    var el = document.getElementById(id);
    if (!el){
      el = document.createElement('div');
      el.id = id;
      el.style.cssText = 'position:fixed;z-index:999999;bottom:8px;left:8px;background:#000;color:#0f0;font:12px/1.3 monospace;padding:6px 8px;border-radius:6px;max-width:70vw;word-break:break-word;opacity:.85;';
      document.body.appendChild(el);
    }
    el.textContent = s;
  }

  function host(){ return document.querySelector(HOST_SEL); }
  function root(){ var h = host(); return (h && h.shadowRoot) ? h.shadowRoot : null; }

  function on(t, e, h, o){
    if (!t) return;
    try { t.addEventListener(e, h, o || {}); }
    catch(_){ t.addEventListener(e, h); }
  }
  function q(r, s){ return r ? r.querySelector(s) : null; }
  function qa(r, s){ return r ? Array.prototype.slice.call(r.querySelectorAll(s)) : []; }
  function text(el){ return el ? (el.textContent || '').replace(/^\s+|\s+$/g,'') : ''; }

  // locale-tolerant numeric
  function num(s){
    s = String(s || '');
    var cleaned = s.replace(/[^\d.,]/g, '');
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot   = cleaned.lastIndexOf('.');
    if (lastComma > lastDot) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    else cleaned = cleaned.replace(/,/g, '');
    var n = +cleaned; return isNaN(n) ? 0 : n;
  }

  function until(cond, cb, ms){
    ms = ms || 60;
    var tries = 0;
    var t = setInterval(function(){
      var ok = false; try { ok = !!cond(); } catch(_){}
      if (ok){ clearInterval(t); cb(); }
      else if (++tries > 600){ clearInterval(t); if (CW_DEBUG) log('timeout'); }
    }, ms);
  }

  function onceStyle(r, id, css){
    if (!r) return;
    if (q(r, '#'+id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.appendChild(document.createTextNode(css));
    r.appendChild(st);
  }

  /* ---------------- fast input + scheduler ---------------- */
  // pointer-first for instant response (fallbacks covered)
  function addFastPress(el, handler){
    if (!el) return;
    var fired = false;
    function wrap(ev){
      if (fired) return;
      fired = true;
      try { handler(ev); } catch(_){}
      setTimeout(function(){ fired = false; }, 0);
    }
    if (window.PointerEvent){
      el.addEventListener('pointerdown', wrap, {passive:true});
    } else {
      el.addEventListener('touchstart', wrap, {passive:true});
      el.addEventListener('mousedown', wrap, {passive:true});
      el.addEventListener('click', wrap, false);
    }
  }
  function nextTick(fn){ setTimeout(fn, 0); }

  // RAF write batching
  var _rafScheduled = false, _rafQueue = [];
  function scheduleWrite(fn){
    _rafQueue.push(fn);
    if (_rafScheduled) return;
    _rafScheduled = true;
    requestAnimationFrame(function(){
      _rafScheduled = false;
      var ql = _rafQueue.slice(); _rafQueue.length = 0;
      for (var i=0;i<ql.length;i++){ try { ql[i](); } catch(_){ } }
    });
  }
  // brief transition kill to avoid jank during switch
  function pulseNoTransitions(r){
    if (!r) return;
    var outer = q(r, '.cw-outer') || r;
    if (!outer || outer.getAttribute('data-switching') === '1') return;
    outer.setAttribute('data-switching','1');
    scheduleWrite(function(){
      setTimeout(function(){ outer.removeAttribute('data-switching'); }, 120);
    });
  }

  // feature probes
  var SUPPORTS_MASK = (function(){ var s = document.documentElement.style; return (('webkitMaskImage' in s) || ('maskImage' in s)); })();

  /* ---------------- shared SVGs ---------------- */
  var CHECK_SVG  = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6.50475 10.2948L11.1906 5.62981L10.4166 4.85577L6.50475 8.74681L4.73396 6.99681L3.95994 7.77081L6.50475 10.2948ZM7.58475 15.1666C6.54535 15.1666 5.56473 14.9693 4.64296 14.5745C3.72117 14.1798 2.91435 13.6367 2.2225 12.9452C1.53064 12.2536 0.98726 11.4472 0.59235 10.5258C0.19745 9.60451 0 8.62411 0 7.58471C0 6.53141 0.19736 5.54737 0.59208 4.63254C0.9868 3.71769 1.52993 2.91435 2.22146 2.2225C2.913 1.53064 3.71945 0.98725 4.64081 0.59235C5.56216 0.19745 6.54255 0 7.58195 0C8.63515 0 9.61925 0.19736 10.534 0.59208C11.4489 0.9868 12.2523 1.52993 12.9442 2.22146C13.636 2.913 14.1793 3.71598 14.5742 4.63039C14.9691 5.5448 15.1667 6.52861 15.1667 7.58191C15.1667 8.62131 14.9693 9.60191 14.5746 10.5237C14.1799 11.4454 13.6367 12.2523 12.9452 12.9441C12.2537 13.636 11.4507 14.1794 10.5363 14.5743C9.62185 14.9692 8.63795 15.1666 7.58475 15.1666Z" fill="black"/></svg>';
  var DENIED_SVG = '<svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M3.99824 9.43416L6.34185 7.09055L8.68546 9.43416L9.43416 8.68546L7.09055 6.34185L9.43416 3.99824L8.68546 3.24954L6.34185 5.59315L3.99824 3.24954L3.24954 3.99824L5.59315 6.34185L3.99824 9.43416ZM6.33806 12.6837C5.4662 12.6837 4.64534 12.5164 3.87546 12.1817C3.10558 11.847 2.43463 11.3937 1.86259 10.8219C1.29056 10.2501 0.837089 9.57891 0.50219 8.8084C0.167397 8.03799 0 7.21618 0 6.34296C0 5.4652 0.16766 4.64018 0.50298 3.86788C0.838301 3.09558 1.29303 2.4222 1.86717 1.84774C2.44142 1.27317 3.11233 0.82155 3.87989 0.492867C4.64745 0.164289 5.4662 0 6.33616 0C7.21423 0 8.04047 0.164236 8.81488 0.492709C9.58928 0.821181 10.263 1.27265 10.836 1.84711C11.4091 2.42156 11.8603 3.09536 12.1897 3.86851C12.519 4.64176 12.6837 5.46789 12.6837 6.34691C12.6837 7.22171 12.5195 8.04168 12.191 8.80682C11.8625 9.57195 11.4111 10.2416 10.8368 10.8159C10.2625 11.3901 9.58886 11.845 8.81582 12.1806C8.04289 12.516 7.21697 12.6837 6.33806 12.6837ZM6.34185 11.6156C7.80586 11.6156 9.05085 11.1016 10.0768 10.0735C11.1027 9.04543 11.6156 7.80154 11.6156 6.34185C11.6156 4.87784 11.1027 3.63285 10.0768 2.60687C9.05085 1.581 7.80586 1.06806 6.34185 1.06806C4.88216 1.06806 3.63827 1.581 2.61019 2.60687C1.5821 3.63285 1.06806 4.87784 1.06806 6.34185C1.06806 7.80154 1.5821 9.04543 2.61019 10.0735C3.63827 11.1016 4.88216 11.6156 6.34185 11.6156Z" fill="#B51A1A"/></svg>';

  /* ---------------- shared re-init wiring ---------------- */
  function bindStart(startFn){
    if (!startFn) return;

    // Custom kick from watcher
    on(document, "cw:skio-reinit", startFn);

    if (document.readyState === "loading") on(document, "DOMContentLoaded", startFn);
    else startFn();

    // Safari BFCache / back from collection
    on(window, "pageshow", function(){ startFn(); });

    // Tab restore / app switch
    on(document, "visibilitychange", function(){
      if (document.visibilityState === "visible") startFn();
    });

    // Theme editor / dynamic sections
    on(document, "shopify:section:load", startFn);
    on(document, "shopify:section:select", startFn);
  }

  /* ---------------- (1) Tabs + One-time hardlist ---------------- */
  (function buildTabsAndHardlist(){
    var HARD_LIST = '' +
      '<ul class="cw-onetime-hardlist">' +
      '<li><span class="cw-denied-wrap"></span>10% off every order</li>' +
      '<li><span class="cw-denied-wrap"></span>Choose delivery every 30, 60 or 90 days</li>' +
      '<li><span class="cw-denied-wrap"></span>Skip, reschedule or cancel any time</li>' +
      '<li><span class="cw-denied-wrap"></span>Prioritized shipping</li>' +
      '</ul>';

    function forceHardList(one){
      if (!one) return;
      one.classList.add('one-time');
      var lists = qa(one, '.cw-onetime-hardlist');
      if (lists.length > 1){
        for (var i=1;i<lists.length;i++){ if (lists[i].parentNode) lists[i].parentNode.removeChild(lists[i]); }
      }
      if (!lists.length){
        var block = document.createElement('div'); block.innerHTML = HARD_LIST;
        if (block.firstElementChild) one.appendChild(block.firstElementChild);
      }
      one.setAttribute('data-cw-hardlist-init','1');
    }

    function setActive(state, ct){
      var r = state.r, tabsEl = state.tabsEl, items = state.items, containers = state.containers, one = state.one;
      scheduleWrite(function(){
        pulseNoTransitions(r);
        for (var i=0;i<containers.length;i++){ containers[i].classList.remove('group-container--selected'); }
        ct.classList.add('group-container--selected');

        for (var c=0;c<tabsEl.children.length;c++){ tabsEl.children[c].classList.remove('is-active'); }
        var idx = 0; for (var j=0;j<items.length;j++){ if (items[j].ct === ct){ idx = j; break; } }
        if (tabsEl.children[idx]) tabsEl.children[idx].classList.add('is-active');

        if (ct === one && one.getAttribute('data-cw-hardlist-init') !== '1') forceHardList(one);
      });
    }

    function injectFastStyles(r){
      var css = '' +
        '.cw-tab{-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none;touch-action:manipulation;}' +
        '.cw-outer[data-switching] *{transition:none!important;animation:none!important;}';
      onceStyle(r, 'cw-fasttap-css', css);
      onceStyle(document.documentElement, 'cw-fasttap-css-light', css);
    }

    function boot(){
      var r = root(); if (!r) { return; }
      var fieldset = q(r, 'fieldset.skio-plan-picker');
      var containers = qa(r, '.group-container');
      if (!fieldset || containers.length < 2) { return; }

      injectFastStyles(r);

      /* ---- CSS: tabs base ---- */
      onceStyle(r, 'cw-tabs-base',
        'fieldset.skio-plan-picker{display:block!important;padding:0;margin:0;border:0;}' +
        '.group-container{margin:0!important;}' +
        '.cw-tabs{display:grid;grid-template-columns:1fr 1fr;width:100%;border:none!important;}' +
        '.cw-tab{display:flex;align-items:center;justify-content:center;padding:12px 16px;font-size:16px;line-height:22px;background:#F6F1E6;color:#0A0A0A;border:0;cursor:pointer;}' +
        '.cw-tab:last-child{border-right:none;}' +
        '.cw-tab.is-active{background:#0A0A0A;color:#fff;box-shadow:0px 2px 2.6px 1px rgba(0,0,0,0.25);}' +
        '.group-container{display:none!important;}' +
        '.group-container.group-container--selected{display:block!important;border:1px solid #E2DED3;border-top:none;background:#F6F1E6;}' +
        '.group-topline .group-title{display:none;}' +
        '@media(max-width:749px){.cw-tab{font-size:15px;padding:12px;}}' +
        '.group-container.one-time .selling-plan-buttons,.group-container.one-time .skio-desktop-selector,.group-container.one-time .skio-mobile-selector{display:none!important;}' +
        '.cw-onetime-hardlist{margin:0!important;padding:6px;list-style:none;background-color:#F2EDE1!important;}' +
        '.cw-onetime-hardlist li{text-decoration:line-through;display:flex;align-items:center;gap:6px;margin:8px 0;font-family:"Apercu",sans-serif!important;}'
      );

      // order: Subscribe first, One-time last
      var items = [];
      for (var i=0;i<containers.length;i++){
        items.push({ ct: containers[i], input: q(containers[i], '.group-input[type="radio"]') });
      }

      (function removePrepaid(){
        function isPrepaid(ct, input){
          if (!ct) return false;
          if (ct.classList && ct.classList.contains('prepaid-option')) return true;

          var v = (input && input.value) ? String(input.value) : '';
          if (/prepaid|year/i.test(v)) return true;

          var t = (ct.textContent || '');
          return /prepaid|yearly/i.test(t);
        }

        var kept = [];
        for (var i=0;i<items.length;i++){
          var ct = items[i].ct;
          var input = items[i].input;
          if (isPrepaid(ct, input)){
            if (ct && ct.parentNode) ct.parentNode.removeChild(ct);
          } else {
            kept.push(items[i]);
          }
        }
        items = kept;
      })();

      containers = [];
      for (var i2=0;i2<items.length;i2++){ containers.push(items[i2].ct); }

      items.sort(function(a,b){
        var av = (a.input && a.input.value) ? a.input.value : '';
        var bv = (b.input && b.input.value) ? b.input.value : '';
        var aOne = /One/i.test(av) ? 1 : 0;
        var bOne = /One/i.test(bv) ? 1 : 0;
        return aOne - bOne;
      });

// build tabs
var tabs = q(r, '.cw-tabs');

if (!tabs) {
  var currentUrl = window.location.href.toLowerCase();

  var locale = currentUrl.includes('de-')
    ? 'de'
    : currentUrl.includes('nl-')
      ? 'nl'
      : 'en';

  var tabTranslations = {
    en: {
      oneTime: 'One-time purchase',
      subscribe: 'Subscribe & Save'
    },
    de: {
      oneTime: 'Einmaliger Kauf',
      subscribe: 'Abonnieren & sparen'
    },
    nl: {
      oneTime: 'Eenmalige aankoop',
      subscribe: 'Abonneren & besparen'
    }
  };

  var tabText = tabTranslations[locale];

  tabs = document.createElement('div');
  tabs.className = 'cw-tabs';

  for (var k = 0; k < items.length; k++) {
    var it = items[k];
    var btn = document.createElement('button');

    btn.type = 'button';
    btn.className = 'cw-tab';

    var val = (it.input && it.input.value)
      ? it.input.value
      : '';

    btn.textContent = /One/i.test(val)
      ? tabText.oneTime
      : tabText.subscribe;

    if (
      it.ct.classList.contains('group-container--selected') ||
      (it.input && it.input.checked)
    ) {
      btn.classList.add('is-active');
    }

    (function (ct, input) {
      addFastPress(btn, function () {
        setActive(state, ct);

        if (input && !input.checked) {
          nextTick(function () {
            input.click();
          });
        }
      });
    })(it.ct, it.input);

    tabs.appendChild(btn);
  }

  fieldset.insertBefore(tabs, containers[0]);
}

      // cache state
      var one = null;
      for (var z=0; z<items.length; z++){
        var v = (items[z].input && items[z].input.value) ? items[z].input.value : '';
        if (/One[\s-]*time/i.test(v)){ one = items[z].ct; break; }
      }
      var state = { r:r, tabsEl:tabs, items:items, containers:containers, one:one };

      // initial selection
      var current = items[0].ct;
      for (var y=0;y<containers.length;y++){
        if (containers[y].classList.contains('group-container--selected')) { current = containers[y]; break; }
      }
      setActive(state, current);

      // keep BG stable with one debounced observer
      try {
        var debouncing = false;
        new MutationObserver(function(){
          if (debouncing) return; debouncing = true;
          requestAnimationFrame(function(){
            debouncing = false;
            var sel = q(r, '.group-container.group-container--selected');
            if (sel) sel.style.background = '#FAF7F0';
          });
        }).observe(r, {subtree:true, childList:true, attributes:true, characterData:false});
      } catch(_){}
    }

    function start(){
      until(function(){ return root() && q(root(), '.group-container'); }, boot);
    }

    bindStart(start);
  })();

  /* ---------------- (2) Price block ---------------- */
  (function priceBlock(){
    function mountStyles(r){
      onceStyle(r, 'cw-price-base',
        '.cw-price-label{font-size:12px;line-height:19.2px;}' +
        '.cw-price-row{display:flex;align-items:center;gap:5px!important;}' +
        '.cw-price-compare{text-decoration:line-through;font-weight:400!important;}' +
        '.cw-price-current{font-weight:700;}' +
        '.cw-badge{font-size:14px!important;line-height:1;padding:6px 10px;border-radius:999px;background:#708266;color:#fff;white-space:nowrap;}'
      );
    }

    function ensurePriceBlock(ct){
      if (!q(ct,'.cw-price-block')){
        var block = document.createElement('div');
        block.className = 'cw-price-block';
        block.innerHTML =
          '<div class="cw-price-label">Price:</div>' +
          '<div class="cw-price-row">' +
          '<span class="cw-price-compare" hidden></span>' +
          '<span class="cw-price-current"></span>' +
          '<span class="cw-badge" hidden></span>' +
          '</div>';
        ct.insertBefore(block, ct.firstChild);
      }
      syncPrice(ct);
    }

    function dedupAndSort(nums){
      var map = {}, arr = [];
      for (var i=0;i<nums.length;i++){ var t = nums[i]; if (!map[t]){ map[t]=1; arr.push({t:t,n:num(t)}); } }
      arr = arr.filter(function(x){ return x.n>0; }).sort(function(a,b){ return b.n-a.n; });
      return arr;
    }

    function extractPrices(scope){
      var curTxt = text(q(scope, '.rc-price:not(.strike-through), .price, .skio-price, [data-price], .group-price'));
      var cmpTxt = text(q(scope, '.strike-through, .compare, .strike, [data-compare-price]'));

      function trySplit(t){
        if (!t) return null;
        var m = t.match(/[$€£]?\s?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})/g) || t.match(/[$€£]?\s?\d+(?:[.,]\d{2})/g);
        if (m && m.length >= 2){
          var uniq = dedupAndSort(m);
          if (uniq.length>=2){
            var cmp = uniq[0], cur = null;
            for (var i=1;i<uniq.length;i++){ if (uniq[i].n < cmp.n){ cur = uniq[i]; break; } }
            if (!cur) cur = cmp;
            return { cmpTxt: cmp.t, curTxt: cur.t };
          }
        }
        return null;
      }

      if (!cmpTxt){
        var s = trySplit(curTxt);
        if (s){ cmpTxt = s.cmpTxt; curTxt = s.curTxt; }
      }

      if (!curTxt && !cmpTxt){
        var bag = [], all = qa(scope, '*');
        for (var k=0;k<all.length;k++){
          var n2 = all[k], t2 = n2.childElementCount ? n2.innerText : n2.textContent;
          if (!t2) continue;
          var mm = t2.match(/[$€£]?\s?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})/g) || t2.match(/[$€£]?\s?\d+(?:[.,]\d{2})/g);
          if (mm){ for (var j=0;j<mm.length;j++) bag.push(mm[j]); }
        }
        var uniq2 = dedupAndSort(bag);
        if (uniq2.length){
          cmpTxt = uniq2[0].t;
          var next = null;
          for (var y=1;y<uniq2.length;y++){ if (uniq2[y].n < uniq2[0].n){ next = uniq2[y]; break; } }
          curTxt = next ? next.t : uniq2[0].t;
        }
      }

      var nCur = num(curTxt), nCmp = num(cmpTxt);
      if (nCur>0 && nCmp>0 && nCur>nCmp){ var tmp=curTxt; curTxt=cmpTxt; cmpTxt=tmp; }
      return { curTxt: curTxt, cmpTxt: cmpTxt };
    }

    function syncPrice(ct){
      var currentOut = q(ct, '.cw-price-current');
      var compareOut = q(ct, '.cw-price-compare');
      var badgeOut   = q(ct, '.cw-badge');
      var p = extractPrices(ct), curTxt = p.curTxt, cmpTxt = p.cmpTxt;

      scheduleWrite(function(){
        if (curTxt) currentOut.textContent = curTxt;
        if (cmpTxt && cmpTxt !== curTxt){ compareOut.textContent = cmpTxt; compareOut.hidden = false; }
        else { compareOut.hidden = true; }

        var badgeTxt = '';
        var nativeBadge = q(ct, '.rc-purchase-option__badge, .badge, .skio-badge');
        if (nativeBadge && /save/i.test(nativeBadge.textContent || '')){
          badgeTxt = (nativeBadge.textContent || '').replace(/^\s+|\s+$/g,'');
        } else {
          var nA = num(curTxt), nB = num(cmpTxt);
          if (nB > nA && nA > 0){
            var pct = Math.round(((nB - nA)/nB)*100);
            if (pct >= 1) badgeTxt = 'Save ' + pct + '%';
          }
        }

        var cfg = window.__cwSkioSyncConfig || {};
        var isOneTime = isOneTimeGroup(ct);

        if (isOneTime){
          badgeTxt = '';
        } else if (isTargetProduct() && is120mlSelected() && cfg.badgeTxt120ml){
          badgeTxt = cfg.badgeTxt120ml;
        }

        if (badgeTxt){ badgeOut.textContent = badgeTxt; badgeOut.hidden = false; } else { badgeOut.hidden = true; }
      });
    }

    function initForSelected(r){
      var sel = q(r, '.group-container.group-container--selected');
      if (sel) ensurePriceBlock(sel);
    }

    var sizeListenerBound = false;

    function boot(){
      var r = root();
      if (!r || !q(r, '.group-container')) return;

      mountStyles(r);
      initForSelected(r);

      var radios = qa(r, '.group-input[type="radio"]');
      for (var i=0;i<radios.length;i++){
        on(radios[i],'change',function(){ initForSelected(r); },{passive:true});
      }

      if (!sizeListenerBound){
        sizeListenerBound = true;
        on(document,'change',function(ev){
          var t = ev.target;
          if (!t || !t.matches || !t.matches('input[type="radio"][name="Size"]')) return;
          scheduleWrite(function(){
            var rr = root();
            if (rr) initForSelected(rr);
          });
        },{passive:true});
      }

      try {
        var pending = false;
        new MutationObserver(function(){
          if (pending) return; pending = true;
          requestAnimationFrame(function(){ pending = false; initForSelected(r); });
        }).observe(r,{subtree:true, childList:true, characterData:true});
      } catch(_){}
    }

    function start(){
      until(function(){ return root() && q(root(), '.group-container'); }, boot);
    }

    bindStart(start);
  })();

  /* ---------------- (3) Kill topline (WAIT + RE-RUN SAFE) ---------------- */
  (function killTopline(){
    function apply(){
      var r = root(); if (!r) return false;

      // Wait until our injected structure exists (prevents iOS timing race)
      if (!q(r,'.cw-outer') || !q(r,'.cw-price-block')) return false;

      onceStyle(r, 'cw-kill-topline-style',
        '.group-topline, label.group-label > .group-topline, .group-topline .skio-radio__container, .group-topline .skio-price { display:none!important; }'
      );
      var toHide = qa(r, '.group-topline, label.group-label > .group-topline, .group-topline .skio-radio__container, .group-topline .skio-price');
      scheduleWrite(function(){
        for (var i=0;i<toHide.length;i++){ toHide[i].style.setProperty('display','none','important'); }
      });

      return true;
    }

    function start(){
      // Stage 1: wait for root, Stage 2: wait for cw-outer + cw-price-block then apply
      until(function(){ return !!root(); }, function(){
        until(function(){ return apply(); }, function(){}, 60);
      });
    }

    bindStart(start);

    // extra safety: if Skio re-renders, try again
    try { new MutationObserver(function(){ start(); }).observe(document.documentElement, { childList:true, subtree:true }); } catch(_){}
  })();

  /* ---------------- (4) Typography ---------------- */
  (function installTypography(){
    function apply(){
      var r = root(); if (!r) return;
      onceStyle(r, 'cw-price-typography',
        '.cw-price-label{font-weight:400!important;font-size:12px!important;line-height:19.2px!important;letter-spacing:.6px!important;text-transform:none!important;}' +
        '.cw-price-compare{font-weight:400!important;font-size:19.68px!important;line-height:31.48px!important;letter-spacing:.98px!important;text-decoration:line-through!important;}' +
        '.cw-price-current{font-weight:700!important;font-size:19.68px!important;line-height:31.48px!important;letter-spacing:.98px!important;}' +
        '.cw-badge{font-weight:400!important;font-size:12px!important;line-height:1!important;letter-spacing:.9px!important;padding:2.5px 13px!important;border-radius:999px!important;background:#708266!important;color:#fff!important;white-space:nowrap!important;}' +
        '@media(max-width:768px){.cw-plan-title,.cw-plan-sub{font-size:13px!important}.cw-plan-badge{font-size:12px!important}}'
      );
    }

    function start(){
      until(function(){ return !!root(); }, apply);
    }

    bindStart(start);
  })();

  /* ---------------- (5) Tabs patches + wrapper + toggle styles ---------------- */
  (function tabsPatchAndWrap(){
    function installTabsStyles(r){
      if (!r) return;
      onceStyle(r, 'cw-tabs-patch',
        '@media(max-width:768px){.cw-outer{box-sizing:border-box!important;border:1px solid #000!important;background:#FAF7F0!important;width:calc(100%)!important;padding:10px!important;}}' +
        '.cw-tabs{box-sizing:border-box!important;width:calc(100% - 32px)!important;margin:16px auto 0!important;display:grid!important;grid-template-columns:1fr 1fr!important;}' +
        '.cw-tab{font-weight:700!important;font-size:18px!important;line-height:22px!important;letter-spacing:.9px!important;text-align:center!important;vertical-align:middle!important;padding:12px 8px!important;color:#0A0A0A!important;background:#fff!important;}' +
        '.cw-tab.is-active{background:#0A0A0A!important;color:#fff!important;}'
      );
    }

    function wrapAll(r){
      if (!r) return;
      if (q(r,'.cw-outer')) return;
      var fieldset = q(r,'fieldset.skio-plan-picker');
      var tabs     = q(r,'.cw-tabs');
      var groups   = qa(r,'.group-container');
      if (!fieldset || !tabs || groups.length < 1) return;

      var outer = document.createElement('div');
      outer.className = 'cw-outer';
      fieldset.insertBefore(outer, tabs);
      outer.appendChild(tabs);
      for (var i=0;i<groups.length;i++){ outer.appendChild(groups[i]); }

      onceStyle(r, 'cw-outer-styles',
        '.cw-outer{box-sizing:border-box!important;border:1px solid #000!important;background:#FAF7F0!important;width:100%!important;padding:10px!important;}' +
        '.group-label{padding:0!important;}' +
        '.cw-outer .cw-tabs{width:100%!important;margin:0 0 12px 0!important;grid-template-columns:1fr 1fr!important;display:grid!important;font-family:Apercu Pro!important;font-weight:400!important;font-style:Regular!important;font-size:18px!important;line-height:22px!important;letter-spacing:.9px!important;text-align:center!important;vertical-align:middle!important;background-color:#FFFFFF!important;}' +
        '.cw-outer .cw-tab{font-family:"Apercu",sans-serif;background:#fff!important;cursor:pointer!important;font-weight:700!important;font-style:Bold!important;line-height:22px!important;letter-spacing:.9px!important;text-align:center!important;vertical-align:middle!important;}' +
        '.cw-outer .cw-tab.is-active{background:#0A0A0A!important;color:#fff!important;margin:5px 6px!important;}' +
        '.cw-outer .group-container{margin:0!important;}' +
        '.cw-outer .group-container.group-container--selected{border:none!important;background:transparent!important;}'
      );
    }

    function applyToggleStyles(r){
      if (!r) return;
      onceStyle(r, 'cw-tabs-toggle-style',
        '.cw-tab{font-size:18px!important;line-height:22px!important;letter-spacing:.9px!important;text-align:center!important;vertical-align:middle!important;border:none!important;transition:all .15s ease-in-out!important;}' +
        '.cw-tab.is-active{background:#000!important;color:#fff!important;font-weight:700!important;}' +
        '.cw-tab:not(.is-active){background:#fff!important;color:#000!important;font-weight:400!important;}' +
        '@media screen and (max-width:768px){.cw-tab{font-size:16px!important}.cw-price-compare,.cw-price-current{font-size:15.96px!important}.cw-badge{font-size:10px!important;padding:3.5px 7.5px!important;line-height:1 !important}.cw-outer .cw-tab{font-size:16px!important;letter-spacing:0!important}.cw-outer{padding:12px 8px!important}}' +
        '@media(min-width:382px){.cw-tab{white-space:nowrap!important}}'
      );

      // cosmetic toggle (instant highlight) — independent of radio
      var tabs = qa(r, '.cw-tab');
      if (tabs.length >= 2){
        for (var i=0;i<tabs.length;i++){
          (function(tab){
            addFastPress(tab, function(){
              for (var j=0;j<tabs.length;j++) tabs[j].classList.remove('is-active');
              tab.classList.add('is-active');
            });
          })(tabs[i]);
        }
      }
    }

    function boot(){
      var r = root();
      if (!r || !q(r,'.cw-tab')) return;
      installTabsStyles(r);
      wrapAll(r);
      applyToggleStyles(r);
    }

    function start(){
      until(function(){ return root() && q(root(), '.cw-tab'); }, boot);
    }

    bindStart(start);
  })();

  /* ---------------- (6) One-time denied icons ---------------- */
  (function deniedIcons(){
    function injectIconCSS(r){
      onceStyle(r, 'cw-icon-style',
        '.cw-denied-wrap{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;flex:0 0 16px;}' +
        '.cw-onetime-hardlist li{display:flex;align-items:center;gap:8px;color:#737373!important;font-family:Apercu Pro!important;font-weight:400!important;font-style:Regular!important;font-size:15px!important;line-height:24px!important;letter-spacing:.6px!important;vertical-align:middle!important;text-decoration:line-through!important;font-family:"Apercu",sans-serif!important;}' +
        '.cw-denied-wrap svg{display:block!important;}'
      );
    }

    function patchOneTime(ct){
      var list = q(ct,'.cw-onetime-hardlist'); if (!list) return;
      var lis = qa(list,'li');
      scheduleWrite(function(){
        for (var i=0;i<lis.length;i++){
          var li = lis[i];
          var svgs = qa(li,'svg'); for (var k=0;k<svgs.length;k++){ if (svgs[k].parentNode) svgs[k].parentNode.removeChild(svgs[k]); }
          var w = q(li,'.cw-denied-wrap');
          if (!w){ w=document.createElement('span'); w.className='cw-denied-wrap'; li.insertBefore(w, li.firstChild); }
          w.innerHTML = DENIED_SVG;
        }
        ct.setAttribute('data-cw-denied-patched','1');
      });
    }

    function apply(){
      var r = root(); if (!r) return;
      injectIconCSS(r);
      var groups = qa(r,'.group-container'); var one = null;
      for (var i=0;i<groups.length;i++){
        if (groups[i].classList.contains('one-time') || /One[\s-]*time/i.test(groups[i].textContent || '')){ one = groups[i]; break; }
      }
      if (one && one.getAttribute('data-cw-denied-patched')!=='1') patchOneTime(one);
    }

    function start(){
      until(function(){ return !!root(); }, function(){
        var r = root();
        apply();
        try {
          var tick = false;
          new MutationObserver(function(){
            if (tick) return; tick = true;
            requestAnimationFrame(function(){ tick = false; apply(); });
          }).observe(r,{subtree:true, childList:true, attributes:true, attributeFilter:['class']});
        } catch(_){}
      });
    }

    bindStart(start);
  })();

  /* ---------------- (7) Hide legacy bullets ---------------- */
  (function hideLegacyBullets(){
    function apply(){
      var r = root(); if (!r) return;
      onceStyle(r, 'cw-hide-legacy-icons',
        '.cw-subscribe-perks li::before, .cw-onetime-hardlist li::before {content:none!important;display:none!important;background:none!important;}' +
        '.cw-subscribe-perks li, .cw-onetime-hardlist li {padding-left:0!important;background:none!important;}' +
        '.cw-subscribe-perks li > svg, .cw-subscribe-perks li > img, .cw-onetime-hardlist li > svg, .cw-onetime-hardlist li > img {display:none!important;}' +
        '.cw-subscribe-perks li > span:not(.cw-check-wrap):not(.cw-denied-wrap) > svg, .cw-onetime-hardlist li > span:not(.cw-check-wrap):not(.cw-denied-wrap) > svg {display:none!important;}' +
        '.cw-check-wrap, .cw-denied-wrap {display:inline-flex!important;}' +
        '.cw-check-wrap svg, .cw-denied-wrap svg {display:block!important;}'
      );
    }

    function start(){
      until(function(){ return !!root(); }, apply);
    }

    bindStart(start);
  })();

  /* ---------------- (8) Subscribe checks: mask (with inline fallback) ---------------- */
  (function subscribeChecks(){
    function injectMaskCSS(r){
      onceStyle(r, 'cw-check-mask',
        '.group-container:not(.one-time) .group-content-additional ul{position:relative;}' +
        '.group-container:not(.one-time) .group-content-additional ul li{position:relative;padding-left:26px;list-style:none!important;}' +
        '.group-container:not(.one-time) .group-content-additional ul li::before{' +
          '-webkit-mask-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><path fill=\'%23fff\' d=\'M6.50475 10.2948L11.1906 5.62981L10.4166 4.85577L6.50475 8.74681L4.73396 6.99681L3.95994 7.77081L6.50475 10.2948ZM7.58475 15.1666C6.54535 15.1666 5.56473 14.9693 4.64296 14.5745C3.72117 14.1798 2.91435 13.6367 2.2225 12.9452C1.53064 12.2536 0.98726 11.4472 0.59235 10.5258C0.19745 9.60451 0 8.62411 0 7.58471C0 6.53141 0.19736 5.54737 0.59208 4.63254C0.9868 3.71769 1.52993 2.91435 2.22146 2.2225C2.913 1.53064 3.71945 0.98725 4.64081 0.59235C5.56216 0.19745 6.54255 0 7.58195 0C8.63515 0 9.61925 0.19736 10.534 0.59208C11.4489 0.9868 12.2523 1.52993 12.9442 2.22146C13.636 2.913 14.1793 3.71598 14.5742 4.63039C14.9691 5.5448 15.1667 6.52861 15.1667 7.58191C15.1667 8.62131 14.9693 9.60191 14.5746 10.5237C14.1799 11.4454 13.6367 12.2523 12.9452 12.9441C12.2537 13.636 11.4507 14.1794 10.5363 14.5743C9.62185 14.9692 8.63795 15.1666 7.58475 15.1666ZM7.58335 14.0833C9.38885 14.0833 10.9236 13.4514 12.1875 12.1875C13.4514 10.9236 14.0833 9.38891 14.0833 7.58331C14.0833 5.77771 13.4514 4.24303 12.1875 2.97914C10.9236 1.71525 9.38885 1.08331 7.58335 1.08331C5.77775 1.08331 4.24303 1.71525 2.97914 2.97914C1.71525 4.24303 1.08331 5.77771 1.08331 7.58331C1.08331 9.38891 1.71525 10.9236 2.97914 12.1875C4.24303 13.4514 5.77775 14.0833 7.58335 14.0833Z\'/></svg>");' +
          'mask-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><path fill=\'%23fff\' d=\'M6.50475 10.2948L11.1906 5.62981L10.4166 4.85577L6.50475 8.74681L4.73396 6.99681L3.95994 7.77081L6.50475 10.2948ZM7.58475 15.1666C6.54535 15.1666 5.56473 14.9693 4.64296 14.5745C3.72117 14.1798 2.91435 13.6367 2.2225 12.9452C1.53064 12.2536 0.98726 11.4472 0.59235 10.5258C0.19745 9.60451 0 8.62411 0 7.58471C0 6.53141 0.19736 5.54737 0.59208 4.63254C0.9868 3.71769 1.52993 2.91435 2.22146 2.2225C2.913 1.53064 3.71945 0.98725 4.64081 0.59235C5.56216 0.19745 6.54255 0 7.58195 0C8.63515 0 9.61925 0.19736 10.534 0.59208C11.4489 0.9868 12.2523 1.52993 12.9442 2.22146C13.636 2.913 14.1793 3.71598 14.5742 4.63039C14.9691 5.5448 15.1667 6.52861 15.1667 7.58191C15.1667 8.62131 14.9693 9.60191 14.5746 10.5237C14.1799 11.4454 13.6367 12.2523 12.9452 12.9441C12.2537 13.636 11.4507 14.1794 10.5363 14.5743C9.62185 14.9692 8.63795 15.1666 7.58475 15.1666ZM7.58335 14.0833C9.38885 14.0833 10.9236 13.4514 12.1875 12.1875C13.4514 10.9236 14.0833 9.38891 14.0833 7.58331C14.0833 5.77771 13.4514 4.24303 12.1875 2.97914C10.9236 1.71525 9.38885 1.08331 7.58335 1.08331C5.77775 1.08331 4.24303 1.71525 2.97914 2.97914C1.71525 4.24303 1.08331 5.77771 1.08331 7.58331C1.08331 9.38891 1.71525 10.9236 2.97914 12.1875C4.24303 13.4514 5.77775 14.0833 7.58335 14.0833Z\'/></svg>");' +
          '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;-webkit-mask-size:100% 100%;mask-size:100% 100%;' +
          'background-color:#000!important;top:6px!important;content:"";position:absolute;left:0;width:16px;height:16px;' +
        '}'
      );
    }

    function injectInlineSVG(r){
      var lists = qa(r, '.group-container:not(.one-time) .group-content-additional ul');
      for (var i=0;i<lists.length;i++){
        var lis = qa(lists[i], 'li');
        for (var j=0;j<lis.length;j++){
          if (!q(lis[j], '.cw-check-wrap')){
            var s = document.createElement('span');
            s.className = 'cw-check-wrap'; s.innerHTML = CHECK_SVG;
            lis[j].insertBefore(s, lis[j].firstChild);
            lis[j].style.paddingLeft = '0';
          }
        }
      }
      onceStyle(r, 'cw-check-inline-style',
        '.cw-check-wrap{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;margin-right:8px;vertical-align:middle;}'
      );
    }

    function boot(){
      var r = root(); if (!r) return;
      if (SUPPORTS_MASK) injectMaskCSS(r);
      else injectInlineSVG(r);
    }

    function start(){
      until(function(){ return !!root(); }, boot);
    }

    bindStart(start);
  })();

})();
} catch(_) {}

/* ===========================
   SKIO SYNC PATCH (yours)
   =========================== */
(function () {
  var PATCH_ID = "cw-skio-sync-v1";

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function schedule(fn) {
    if (window.requestAnimationFrame) return requestAnimationFrame(fn);
    setTimeout(fn, 0);
  }

  function fire(el, type) {
    if (!el) return;
    try {
      el.dispatchEvent(new Event(type, { bubbles: true }));
    } catch (_) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent(type, true, false);
        el.dispatchEvent(ev);
      } catch (_) {}
    }
  }

  function getSkioRoot() {
    var pickers = qsa("skio-plan-picker");
    for (var i = 0; i < pickers.length; i++) {
      var p = pickers[i];
      var r = p.shadowRoot || p;
      if (r && qs(".cw-tabs", r) && qs(".group-input", r)) return r;
    }
    var any = qs(".cw-tabs") && qs(".group-input") ? document : null;
    return any;
  }

  function getTabs(root) {
    var tabsEl = qs(".cw-tabs", root);
    if (!tabsEl) return { tabsEl: null, subTab: null, oneTab: null };
    var kids = tabsEl.children || [];
    var subTab = null;
    var oneTab = null;

    for (var i = 0; i < kids.length; i++) {
      var b = kids[i];
      var tx = (b && b.textContent ? b.textContent : "").toLowerCase();
      if (!subTab && tx.indexOf("subscribe") > -1) subTab = b;
      if (!oneTab && (tx.indexOf("one-time") > -1 || tx.indexOf("one time") > -1)) oneTab = b;
    }
    if (!subTab) subTab = kids[0] || null;
    if (!oneTab) oneTab = kids[1] || null;

    return { tabsEl: tabsEl, subTab: subTab, oneTab: oneTab };
  }

  function isOneTimeInput(input) {
    if (!input) return false;
    var v = (input.value || "").toLowerCase();
    if (v.indexOf("one time") > -1 || v.indexOf("one-time") > -1) return true;
    if (input.id && input.id.toLowerCase().indexOf("one-time") === 0) return true;
    var ct = input.closest ? input.closest(".group-container") : null;
    if (ct && ct.classList && ct.classList.contains("group-container--last")) {
      if (qs(".one-time-group-label", ct)) return true;
    }
    return false;
  }

  function getCheckedGroupInput(root) {
    return qs('.group-input[type="radio"]:checked', root);
  }

  function getSubscribeGroupInput(root) {
    var inputs = qsa('.group-input[type="radio"]', root);
    for (var i = 0; i < inputs.length; i++) {
      if (!isOneTimeInput(inputs[i])) return inputs[i];
    }
    return null;
  }

  function syncTabsToCheckedGroup(root) {
    var t = getTabs(root);
    if (!t.tabsEl) return;

    var checked = getCheckedGroupInput(root);
    if (!checked) return;

    var one = isOneTimeInput(checked);

    for (var i = 0; i < t.tabsEl.children.length; i++) {
      t.tabsEl.children[i].classList.remove("is-active");
    }
    if (one && t.oneTab) t.oneTab.classList.add("is-active");
    if (!one && t.subTab) t.subTab.classList.add("is-active");
  }

  function ensureSubscribeSelected(root) {
    var subInput = getSubscribeGroupInput(root);
    if (!subInput) return false;

    if (!subInput.checked) {
      var lbl = root.querySelector('label[for="' + subInput.id + '"]');
      if (lbl) lbl.click();
      else subInput.click();
      fire(subInput, "change");
      fire(subInput, "input");
    }

    var t = getTabs(root);
    if (t.subTab && !t.subTab.classList.contains("is-active")) {
      t.subTab.click();
    }

    schedule(function () {
      syncTabsToCheckedGroup(root);
    });

    return true;
  }

  function ensureFirstIntervalSelected(root) {
    var changed = false;

    var desktopFirst = qs('#selling_plan_button-710219465090', root);
    if (!desktopFirst) {
      var desktopInputs = qsa('.selling-plan-buttons input[type="radio"]', root);
      desktopFirst = desktopInputs[0] || null;
    }
    if (desktopFirst && !desktopFirst.checked) {
      var lbl = root.querySelector('label[for="' + desktopFirst.id + '"]');
      if (lbl) lbl.click();
      else desktopFirst.click();
      fire(desktopFirst, "change");
      fire(desktopFirst, "input");
      changed = true;
    }

    var sel = qs("select.selling-plan-dropdown", root);
    if (sel && sel.options && sel.options.length) {
      var wanted = "710219465090";
      var hasWanted = false;
      for (var i = 0; i < sel.options.length; i++) {
        if (String(sel.options[i].value) === wanted) {
          hasWanted = true;
          break;
        }
      }
      var target = hasWanted ? wanted : String(sel.options[0].value);
      if (String(sel.value) !== target) {
        sel.value = target;
        fire(sel, "change");
        fire(sel, "input");
        changed = true;
      }
    }

    return changed;
  }

  function wireVariantRadios() {
    var radios = qsa('variant-radios input[type="radio"][name]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (r.getAttribute("data-" + PATCH_ID)) continue;
      r.setAttribute("data-" + PATCH_ID, "1");
      r.addEventListener(
        "change",
        function () {
          schedule(function () {
            var root = getSkioRoot();
            if (!root) return;
            ensureSubscribeSelected(root);
            ensureFirstIntervalSelected(root);
            syncTabsToCheckedGroup(root);
          });
        },
        true
      );
      r.addEventListener(
        "click",
        function () {
          schedule(function () {
            var root = getSkioRoot();
            if (!root) return;
            ensureSubscribeSelected(root);
            ensureFirstIntervalSelected(root);
            syncTabsToCheckedGroup(root);
          });
        },
        true
      );
    }
  }

  var observerStarted = false;
  function ensureObserver() {
    if (observerStarted) return;
    observerStarted = true;

    var lastRoot = null;

    setInterval(function () {
      var root = getSkioRoot();
      if (!root || root === lastRoot) return;
      lastRoot = root;

      try {
        var mo = new MutationObserver(function () {
          schedule(function () {
            var r = getSkioRoot();
            if (!r) return;
            syncTabsToCheckedGroup(r);
          });
        });
        mo.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "checked", "aria-checked"]
        });
      } catch (_) {}
    }, 250);
  }

  function boot() {
    ensureObserver();
    wireVariantRadios();

    schedule(function () {
      var root = getSkioRoot();
      if (!root) return;

      ensureSubscribeSelected(root);
      ensureFirstIntervalSelected(root);
      syncTabsToCheckedGroup(root);
    });
  }

  // expose for watcher (safe)
  try { window.__cwSkioSyncBoot = boot; } catch(_){}

  function start(){
    boot();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // BFCache + tab restore + Shopify dynamic
  window.addEventListener("pageshow", start);
  document.addEventListener("visibilitychange", function(){
    if (document.visibilityState === "visible") start();
  });
  document.addEventListener("shopify:section:load", start);
  document.addEventListener("shopify:section:select", start);

  // watcher kick
  document.addEventListener("cw:skio-reinit", start);
})();

/* ===========================
   RELIABILITY WATCHER (Skio re-renders / hydration)
   Triggers cw:skio-reinit when .cw-* nodes are missing
   =========================== */
(function(){
  var RECHECK_MS = 200;
  var lastHost = null;
  var lastRoot = null;

  function findHost(){
    return document.querySelector("skio-plan-picker");
  }

  function getRoot(host){
    if (!host) return null;
    return host.shadowRoot || null;
  }

  function needsRebuild(root){
    if (!root) return true;
    if (!root.querySelector(".cw-tabs")) return true;
    // outer + price block are your key injections that sometimes get wiped
    if (!root.querySelector(".cw-outer")) return true;
    if (!root.querySelector(".cw-price-block")) return true;
    return false;
  }

  function kick(){
    // run your patched boot paths (no reliance on DOMContentLoaded)
    try {
      document.dispatchEvent(new Event("cw:skio-reinit"));
    } catch(_){
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("cw:skio-reinit", true, false);
        document.dispatchEvent(ev);
      } catch(__){}
    }
    // also ping sync boot directly if available
    try { if (window.__cwSkioSyncBoot) window.__cwSkioSyncBoot(); } catch(_){}
  }

  function check(){
    var host = findHost();
    var root = getRoot(host);

    // host/root changed (hydrate / rehydrate)
    if (host && (host !== lastHost || root !== lastRoot)){
      lastHost = host;
      lastRoot = root;
      if (root) kick();
      return;
    }

    // root exists but Skio wiped our nodes
    if (root && needsRebuild(root)){
      kick();
    }
  }

  // DOM watcher for insertion + re-render
  try {
    new MutationObserver(function(){
      check();
    }).observe(document.documentElement, { childList:true, subtree:true });
  } catch(_){}

  // periodic safety net (cheap)
  setInterval(check, RECHECK_MS);

  // BFCache / restore
  window.addEventListener("pageshow", check);
  document.addEventListener("visibilitychange", function(){
    if (document.visibilityState === "visible") check();
  });
})();